import router from '../../../router'
import { SortedTable, SortLink } from 'vue-sorted-table'
import NavigationBar from '../../../components/navigation-bar/NavigationBar'
import TabBar from '../../../components/tab-bar/TabBar'
import InputText from '../../../components/input-text/InputText'
import InputButton from '../../../components/input-button/InputButton'
import InputDropdownFilter from '../../../components/input-dropdown-filter/InputDropdownFilter'
import Loader from '../../../components/loader/Loader'
import SettingsHeader from '../../../components/settings-header/SettingsHeader'
import { RegionService, Region } from '../../../services/region.service'
import { LocationService, LocationDropdown, Location } from '../../../services/location.service'
import { Constants } from '../../../constants'
import { ScreenLoader } from '../../../utils/loading.util'

export default {
    name: 'Region',
    components: {
        NavigationBar,
        TabBar,
        InputText,
        InputDropdownFilter,
        InputButton,
        Loader,
        SettingsHeader,
        SortedTable,
        SortLink,
    },

    data() {
        return {
            region: new Region(),
            locations: [],
            dropdownLocations: [],
            screenLoader: new ScreenLoader()
        }
    },

    mounted() {
        this.getMetaData()
    },

    methods: {   
        doClear(reference) {
            this.region[reference] = ''
        },

        doSave() {
            if (this.region.name) {
                if (this.region.id == undefined) {
                    this.createRegion()
                }else{
                    this.updateRegion()
                }
            }else{
                for (const ref in this.$refs) {
                    if (this.$refs[ref] != undefined) {
                        this.$refs[ref].checkForError()
                    }
                }
            }
        },

        doCancel() {
            router.push(`/settings/regions`)
        },

        getMetaData: async function() {
            this.screenLoader.start(['region'])

            try {
                const locations = await LocationService.getLocations()
                this.handleMetaDataResponse(locations)
            } catch (error) {
                this.screenLoader.stopWithError(error)
            }
        },

        getRegion: async function() {
             try {
                const region = await RegionService.getRegion(this.$route.params.id)
                this.handleRegionResponse(region)
            } catch (error) {
                this.screenLoader.stopWithError(error)
            }
        },

        createRegion: async function() {
            this.screenLoader.start()

            try {
                const response = await RegionService.createRegion(this.region)
                this.handleMutateRegionResponse(response, 'The region has been successfully created')
            } catch (error) {
                this.screenLoader.stopWithError(error)
            }
        },

        updateRegion: async function() {
            this.screenLoader.start()

            try {
                const response = await RegionService.updateRegion(this.region)
                this.handleMutateRegionResponse(response, 'The region has been successfully updated')
            } catch (error) {
                this.screenLoader.stopWithError(error)
            }
        },

        handleMetaDataResponse(locations) {
            this.locations = locations.map(o => new Location(o))
            this.dropdownLocations = locations.map(o => new LocationDropdown(o))
            
            if (this.$route.params.id != 'new') {
                this.getRegion()
            }else{
                this.screenLoader.stop(['region'])
            }
        },

        handleRegionResponse(region) {
            this.region = new Region(region)
            this.screenLoader.stop(['region'])
        },

        handleMutateRegionResponse(response, message) {
            this.$store.dispatch(Constants.STORE_ACTION_CREATE_ALERT, {code: response.status, message: message })
            router.push(`/settings/regions`)
        },

        addLocation(id) {
            const location = this.region.locations.filter(location => location.id == id)
            if (location.length == 0) {
                this.region.locations.push(this.locations.filter(location => location.id == id)[0])
            }
        },

        removeLocation(id) {
            this.region.locations = this.region.locations.filter(location => location.id != id)
        }
    }
}